
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("OrigenUsuarioApi");
const crud = rpcCrudService<models.OrigenUsuarioApi, models.OrigenUsuarioApiDto>(controller);


export const origenesUsuarioApi = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */
    query: async (id: number): Promise<models.OrigenUsuarioApiDto[]> => await controller("Query", {id}),
}, {
    query: true,
    getMemo: true,
}, {
    add: true,
    delete: true,
    update: true
});



// WEBPACK FOOTER //
// ./app/resources/items/usuarioapi.tsx